<div class="w-100 d-flex flex-wrap gap-tiny">
  <div class="w-100 d-flex align-items-center">
    <div class="d-flex align-items-center gap-small">
      <img
        src="./wealth-assets/svg/profit-icon.svg"
        alt=""
      />

      <p class="c-2 text-onback-medium">سود سالانه {{ wallet()?.profit.dailyPercentage }} به صورت روز شمار</p>
    </div>

    <ngx-button
      [style]="'link'"
      [mode]="'icon-only'"
      [size]="'small'"
      [leftIcon]="{ name: 'question-mark-circle' }"
      [ngxTooltip]="'سود شما دو روز بعد از هر واریزی قابل مشاهده است.'"
      [tooltipPosition]="'top'"
      [tooltipType]="'click'"
      [closeTimeout]="3000"
    ></ngx-button>
  </div>
  @if (!wallet()?.hasTransactions) {
    <div class="w-100 d-flex flex-wrap mt-small px-small">
      <p class="w-100 st-7 text-onback-high">نه سود گرفتی نه اعتبار!</p>
      <p class="w-100 b-3 text-onback-medium">برای شروع مبلغ دلخواهت رو واریز کن.</p>
    </div>
  } @else {
    @if (wallet()?.profit.totalProfit) {
      <div class="w-100 d-flex align-items-center gap-tiny mt-small">
        <p class="st-7 text-onback-high">از روز اول</p>
        <p class="st-7 text-onback-high d-flex flex-wrap gap-tiny align-items-center">
          <span class="st-5 text-onback-success">
            {{ wallet()?.profit.totalProfit | thousands }}
          </span>
          <span class="st-8 text-onback-high">ریال</span>
          <span class="st-7 text-onback-high">سود گرفتی!</span>
        </p>
      </div>
    }
  }
</div>
